import { defineNuxtPlugin } from 'nuxt/app';

export default defineNuxtPlugin(() => {
  // Composable filter replacements
  // These are now available in utils/fieldGetters.ts as composables
});
